/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var rpc_admin_image_pb = require('../../rpc/admin/image_pb.js');
goog.object.extend(proto, rpc_admin_image_pb);
var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.admin.DavidsonsProduct', null, global);
goog.exportSymbol('proto.admin.GetDavidsonsProductRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.DavidsonsProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.DavidsonsProduct.repeatedFields_, null);
};
goog.inherits(proto.admin.DavidsonsProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.DavidsonsProduct.displayName = 'proto.admin.DavidsonsProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetDavidsonsProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GetDavidsonsProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetDavidsonsProductRequest.displayName = 'proto.admin.GetDavidsonsProductRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.DavidsonsProduct.repeatedFields_ = [29];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.DavidsonsProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.DavidsonsProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.DavidsonsProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.DavidsonsProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msp: +jspb.Message.getFieldWithDefault(msg, 3, 0.0),
    retailPrice: +jspb.Message.getFieldWithDefault(msg, 4, 0.0),
    dealerPrice: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
    salePrice: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
    saleEnds: jspb.Message.getFieldWithDefault(msg, 7, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 8, 0),
    upcCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 10, ""),
    gunType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    modelSeries: jspb.Message.getFieldWithDefault(msg, 12, ""),
    caliber: jspb.Message.getFieldWithDefault(msg, 13, ""),
    action: jspb.Message.getFieldWithDefault(msg, 14, ""),
    capacity: jspb.Message.getFieldWithDefault(msg, 15, ""),
    finish: jspb.Message.getFieldWithDefault(msg, 16, ""),
    stock: jspb.Message.getFieldWithDefault(msg, 17, ""),
    sights: jspb.Message.getFieldWithDefault(msg, 18, ""),
    barrelLength: +jspb.Message.getFieldWithDefault(msg, 19, 0.0),
    overallLength: +jspb.Message.getFieldWithDefault(msg, 20, 0.0),
    features: jspb.Message.getFieldWithDefault(msg, 21, ""),
    quantityNc: jspb.Message.getFieldWithDefault(msg, 22, 0),
    quantityAz: jspb.Message.getFieldWithDefault(msg, 23, 0),
    productClass: jspb.Message.getFieldWithDefault(msg, 24, ""),
    magCapacity: jspb.Message.getFieldWithDefault(msg, 25, ""),
    basePrice: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
    minPrice: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
    pictFile: jspb.Message.getFieldWithDefault(msg, 28, ""),
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    rpc_admin_image_pb.Image.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.DavidsonsProduct}
 */
proto.admin.DavidsonsProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.DavidsonsProduct;
  return proto.admin.DavidsonsProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.DavidsonsProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.DavidsonsProduct}
 */
proto.admin.DavidsonsProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMsp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRetailPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDealerPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSalePrice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSaleEnds(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpcCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setGunType(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelSeries(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaliber(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapacity(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinish(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setStock(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSights(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBarrelLength(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOverallLength(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeatures(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantityNc(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantityAz(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductClass(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setMagCapacity(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBasePrice(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinPrice(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictFile(value);
      break;
    case 29:
      var value = new rpc_admin_image_pb.Image;
      reader.readMessage(value,rpc_admin_image_pb.Image.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.DavidsonsProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.DavidsonsProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.DavidsonsProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.DavidsonsProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsp();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getRetailPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDealerPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSalePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getSaleEnds();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getUpcCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGunType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getModelSeries();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCaliber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCapacity();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFinish();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStock();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSights();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBarrelLength();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getOverallLength();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getFeatures();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getQuantityNc();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getQuantityAz();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getProductClass();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getMagCapacity();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getBasePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getMinPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getPictFile();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      29,
      f,
      rpc_admin_image_pb.Image.serializeBinaryToWriter
    );
  }
};


/**
 * optional string item_number = 1;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getItemNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setItemNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string item_description = 2;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getItemDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setItemDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double msp = 3;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getMsp = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setMsp = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double retail_price = 4;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getRetailPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setRetailPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double dealer_price = 5;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getDealerPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setDealerPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double sale_price = 6;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getSalePrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setSalePrice = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string sale_ends = 7;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getSaleEnds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setSaleEnds = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 quantity = 8;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setQuantity = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string upc_code = 9;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getUpcCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setUpcCode = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string manufacturer = 10;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string gun_type = 11;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getGunType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setGunType = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string model_series = 12;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getModelSeries = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setModelSeries = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string caliber = 13;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getCaliber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setCaliber = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string action = 14;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setAction = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string capacity = 15;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setCapacity = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string finish = 16;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getFinish = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setFinish = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string stock = 17;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getStock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setStock = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string sights = 18;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getSights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setSights = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional double barrel_length = 19;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getBarrelLength = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 19, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setBarrelLength = function(value) {
  jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double overall_length = 20;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getOverallLength = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 20, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setOverallLength = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional string features = 21;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getFeatures = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setFeatures = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int32 quantity_nc = 22;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getQuantityNc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setQuantityNc = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int32 quantity_az = 23;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getQuantityAz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setQuantityAz = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string product_class = 24;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getProductClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setProductClass = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string mag_capacity = 25;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getMagCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setMagCapacity = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional double base_price = 26;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getBasePrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setBasePrice = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double min_price = 27;
 * @return {number}
 */
proto.admin.DavidsonsProduct.prototype.getMinPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.admin.DavidsonsProduct.prototype.setMinPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional string pict_file = 28;
 * @return {string}
 */
proto.admin.DavidsonsProduct.prototype.getPictFile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.admin.DavidsonsProduct.prototype.setPictFile = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * repeated Image images = 29;
 * @return {!Array<!proto.admin.Image>}
 */
proto.admin.DavidsonsProduct.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.admin.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_image_pb.Image, 29));
};


/** @param {!Array<!proto.admin.Image>} value */
proto.admin.DavidsonsProduct.prototype.setImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 29, value);
};


/**
 * @param {!proto.admin.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Image}
 */
proto.admin.DavidsonsProduct.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.admin.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.DavidsonsProduct.prototype.clearImagesList = function() {
  this.setImagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetDavidsonsProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetDavidsonsProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetDavidsonsProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetDavidsonsProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetDavidsonsProductRequest}
 */
proto.admin.GetDavidsonsProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetDavidsonsProductRequest;
  return proto.admin.GetDavidsonsProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetDavidsonsProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetDavidsonsProductRequest}
 */
proto.admin.GetDavidsonsProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetDavidsonsProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetDavidsonsProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetDavidsonsProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetDavidsonsProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string item_number = 1;
 * @return {string}
 */
proto.admin.GetDavidsonsProductRequest.prototype.getItemNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.GetDavidsonsProductRequest.prototype.setItemNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.admin);
